module.exports = {"522626100":"思旸镇","522626101":"水尾镇","522626102":"天马镇","522626103":"龙田镇","522626104":"大有镇","522626105":"注溪镇","522626106":"凯本镇","522626107":"平庄镇","522626108":"客楼镇","522626202":"天星乡","522626203":"羊桥土家族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522626.json
// module id = 2515
// module chunks = 0